import Styled from 'styled-components';
import {
  Card,
  CardActions,
} from '@one-thd/sui-atomic-components';
import { desktop, tablet, mobile } from '../../utils/constants';

export const CustomCard = Styled(Card)`
  display:block;
  @media all and (min-width: ${desktop}) {
    display:block;
  }
   @media all and (max-width: 767px) and (min-width: ${mobile}) {
    height: 147px;
  }
`;

export const CustomCardActions = Styled(CardActions)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  bottom: 0;

  @media all and (max-width: 767px) and (min-width: ${mobile}) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    bottom: 0;
    
  }
`;

export const SquareFeet = Styled.div`
margin-top: 4px;
top: 20px;
position: relative;
`;
